<template>
  <div class="cp-win mobile">
    <div class="prize"></div>
    <div v-if="data.length" class="prize-wrapper">
      <Prize
        v-for="(prize, index) in data"
        :key="index"
        :prize="prize.icon"
        :name="prize.title"
        :class="`prize prize-${index + 1}`"
        :ref="`prize-${index + 1}`"
      >
      </Prize>
    </div>
    <div v-show="showButtons" class="button" @click="showShare"></div>
    <div v-show="showButtons" class="button draw" @click="lotto"></div>
    <div v-show="showButtons" class="desc">召集助力，增加更多十连次数！</div>
    <div v-show="showButtons" class="desc times">还能抽<span class="emphasis">{{chance}}</span>次</div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
// 移动端头部
import { isMobile, setStore, getParameterByName } from '~/tools/utils'
import Close from '~/components/Close/close.vue';
import api from '~/api/api'
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Prize from "~/components/Prize/index.vue";
import { mapState } from "vuex";
import Alert from "~/components/Alert";

export default {
  name: 'Info',
  components: {Close, Prize},
  props: {
    win: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      wxtitle: "《原始征途》世界杯竞猜——竞猜赢大奖，畅享世界杯！",
      wxdesc: "预约《原始征途》手游并参与2022卡塔尔世界杯竞猜活动，赢大奖iphone及周边豪礼！",
      wximages: "https://" + window.location.host + "/act/blc/share.jpg",
      isMobile: isMobile(),
      loading: false,
      data: [],
      showButtons: false,
      ingame: getParameterByName("ingame")
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      chance: state => state.chance,
      prizeList: state => state.prizeList,
      modal: state => state.modal
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.data = this.modal.win
    })
    setTimeout(() => {
      this.showButtons = true
    }, 2660)
  },
  beforeDestroy() {
    this.data = []
  },
  methods: {
    lotto() {
      if(!this.chance) {
        // Alert("您已没有抽奖次数了")
        store.commit(types.SHOW_MODAL, {type: 'times'});
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      api.lotto().then(res => {
        if(res.status === 1) {
          this.data = [];
          this.chance--
          store.commit(types.UPDATE_CHANCE, this.chance);
          Array.from(Array(10).keys()).forEach(x => {
            this.$refs[`prize-${x + 1}`].className = "prize"
          })
          setTimeout(() => {
            res.info.item_detail.forEach(x => this.data.push(x));
            Array.from(Array(10).keys()).forEach(x => {
              this.$refs[`prize-${x + 1}`].className = `prize prize-${x + 1}`
            })
          }, 0);
          this.showButtons = false;
          setTimeout(() => {
            this.showButtons = true
          }, 2660)
          return api.getPrizeList();
        }
      }).then(res => {
        if(res && res.status === 1) {
          let prizeList = Object.assign({}, this.prizeList, {
            list: res.list.reduce((a, b) => a.concat(b), [])
          })
          store.commit(types.UPDATE_PRIZE, prizeList);
        }
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch((e) => {
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    showShare() {
      if(this.ingame) {
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: window.location.origin + `/act/blc/#/share?fid=${this.userInfo.shareinfo.userid}`})
      } else {
        store.commit(types.SHOW_MODAL, {type: 'share'});
      }
      // setShare({
      //   link: window.location.origin + `/act/blc/#/share?fid=${this.userInfo.shareinfo.userid}`,
      //   type: "link",
      //   title: this.wxtitle,
      //   desc: this.wxdesc,
      //   imgUrl: this.wximages
      // });
      // if(this.ingame) {
      //   window.wx.miniProgram.postMessage({data:{ fid: this.userInfo.shareinfo.userid }});
      // }
    },
    onSelect(data_id) {
      // console.log(data_id)
      this.data_id = data_id
      setStore('data_id', data_id)
    },
    goToQuestion() {
      if(this.checked) {
        location.href = ''
      }
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-win
    position absolute
    width 6.92rem
    height 8.37rem
    background-image url('./images/prize.png')
    background-size: 6.92rem 7.41rem;
    background-repeat: no-repeat;
    background-position 0 0
    .desc
      position absolute
      top 6.42rem
      left 1.09rem
      font-size 0.24rem
      line-height 0.24rem
      color #000
      font-weight bold
      animation fadeIn 0.3s ease
      &.times
        left 4.58rem
        width 1.26rem
        text-align center
        .emphasis
          color: #b42d00
          margin: 0 0.07rem
          display inline-block
    .prize-wrapper
      margin 1.41rem 0 0 0.56rem
      position relative
      display flex
      flex-wrap wrap
      .prize
        position absolute
        left 2.36rem
        top 0.85rem
        opacity 0
        &-1
          z-index 10
          animation prize-1 0.38s linear forwards
        &-2
          z-index 9
          animation prize-2 0.22s linear 0.38s forwards
        &-3
          z-index 8
          animation prize-3 0.13s linear 0.6s forwards
        &-4
          z-index 7
          animation prize-4 0.22s linear 0.73s forwards
        &-5
          z-index 6
          animation prize-5 0.38s linear 0.95s forwards
        &-6
          z-index 5
          animation prize-6 0.38s linear 1.33s forwards
        &-7
          z-index 4
          animation prize-7 0.22s linear 1.71s forwards
        &-8
          z-index 3
          animation prize-8 0.13s linear 1.93s forwards
        &-9
          z-index 2
          animation prize-9 0.22s linear 2.06s forwards
        &-10
          z-index 1
          animation prize-10 0.38s linear 2.28s forwards
    .button
      width 2.27rem
      height 0.81rem
      background-size: 100% 100%;
      background-image url('./images/go.png')
      background-repeat: no-repeat;
      position absolute
      top 5.26rem
      left 0.94rem
      animation fadeIn 0.3s ease
      &.draw
        left 3.74rem
        background-image url('./images/continue.png')

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
@keyframes prize-1 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(-0.85rem)
  }
}
@keyframes prize-2 {
  to {
    opacity: 1
    transform: translateX(-1.18rem) translateY(-0.85rem)
  }
}
@keyframes prize-3 {
  to {
    opacity: 1
    transform: translateX(0) translateY(-0.85rem)
  }
}
@keyframes prize-4 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(-0.85rem)
  }
}
@keyframes prize-5 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(-0.85rem)
  }
}
@keyframes prize-6 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(0.85rem)
  }
}
@keyframes prize-7 {
  to {
    opacity: 1
    transform: translateX(-1.18rem) translateY(0.85rem)
  }
}
@keyframes prize-8 {
  to {
    opacity: 1
    transform: translateX(0) translateY(0.85rem)
  }
}
@keyframes prize-9 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(0.85rem)
  }
}
@keyframes prize-10 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(0.85rem)
  }
}
</style>
